import Modal from '@/components/modal/Modal.vue'
import MapList from '@/components/mapList/MapList.vue'
import Search from '@/components/search/Search.vue'
import DropdownSelect from '@/components/dropdownSelect/DropdownSelect.vue'
import { isContains } from '@/components/utils/isContains'

export default {
  name: 'SearchMapLevel',
  props: {
    maps: {
      type: Array,
      default: () => []
    },
    routeName: {
      type: String,
      default: 'map' // map || views
    }
  },
  data() {
    return {
      modalShow: false,
      search: '',
      selectedMapGroups: [],
      mapListKey: false
    }
  },
  computed: {
    groupOptions() {
      return this.maps.map(mapGroup => {
        const groupOption = { ...mapGroup }
        delete groupOption.map
        return groupOption
      })
    },
    mapsCmp() {
      let result = []; 
      // фильтр по выбранным группам
      result = this.maps.filter(mapGroup => {
        if (!this.selectedMapGroups.length) return true
        return this.selectedMapGroups.find(selectedGroup => selectedGroup.id === mapGroup.id) !== undefined
      });
      result = result.map(mapGroup => {
        return {
          ...mapGroup,
          map: mapGroup.map.reduce((acc, map) => {
            /**
             * при рекурсии this.getAllMapParents, карта уже может быть доабвлена,
             */
            if (acc.find(mapAcc => mapAcc.id === map.id) === undefined) {
              /**
               * Подмешиваем новые свойства из стора
               */
              let mapObjects = this.$store.getters.getCamsMap(map.objects);
              // фильтр по моделке поиска
              mapObjects = mapObjects.filter(cam => isContains(this.search, cam.name, true)) 
              
              if (isContains(this.search, map.name, true) || mapObjects.length) {
                let mapParents = []
                /**
                 * избегаем строгого равенства
                 */
                if (map.parent &&  acc.find(accMap => accMap.id == map.parent) === undefined) {
                  mapParents = this.getAllMapParents(map, mapGroup.map, [])
                }

                return [
                  ...acc,
                  ...mapParents,
                  {
                    ...map,
                    objects: mapObjects
                  }
                ].sort((a, b) => {
                  return a.id - b.id
                })
              }
            }
            return acc
          }, [])
        }
      }, [])
      // Если во вложенных уровнях и объектах нет совпадений по search моделе, то
      // филтруем названия групп по search моделе
      result = result.filter(mapGroup => {
        if(!mapGroup.map.length) {
          return isContains(this.search, mapGroup.name, true)
        } else return mapGroup
      });
      return result
    }
  },
  methods: {
    isContains,
    /**
     * 
     * @param {*} map - карта по которой ищем родителей
     * @param {*} arrayGroup - общий массив по которому ищем родителей
     * @param {*} acc - результирующий массив
     */
    getAllMapParents(map, arrayGroup, acc = []) {
      if (map.parent) {
        /**
         * избегаем строгого равенства
         */
        const parentMap = arrayGroup.find(mapObject => mapObject.id == map.parent)
        const parentMapObjects = this.$store.getters.getCamsMap(parentMap.objects)
          .filter(cam => isContains(this.search, cam.name, true)) 
        const newAcc = [ ...acc, {
          ...parentMap,
          objects: parentMapObjects
        }]
        return this.getAllMapParents(parentMap, arrayGroup, newAcc)
      }
      return acc
    },

    clearFilters() {
      this.search = ''
      this.selectedMapGroups = []
      this.mapListKey = !this.mapListKey
    },

    openModal() {
      this.modalShow = true
      document.getElementById('container').dataset.modal = true;
    },
    hideModal() {
      this.clearFilters()
      this.modalShow = false
      document.getElementById('container').dataset.modal = false;
    }
  },
  components: {
    Modal,
    MapList,
    Search,
    DropdownSelect
  }
}


// WEBPACK FOOTER //
// ./src/components/searchMapLevel/searchMapLevel.js